<mat-card appearance="outlined" *ngIf="!!dynamicContent">
  <div class="title-container">
    <mat-form-field>
      <mat-label>{{'general.title' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.title" matInput required/>
    </mat-form-field>
  </div>
  <ng-container *ngIf="!onlyTitle">
    <smart-input [hideDescription]="true" [key]="'webcamType'" [model]="dynamicContent.content"
                 translationKey="dynamicContent.webcam.webcamType"></smart-input>
    <smart-input [hideDescription]="true" [key]="'webcamUrl'" [model]="dynamicContent.content"
                 translationKey="dynamicContent.webcam.webcamUrl"></smart-input>
    <smart-input *ngIf="dynamicContent.content.webcamType === 'video' || dynamicContent.content.webcamType === 'iframe'"
                 [hideDescription]="true" [key]="'previewUrl'" [model]="dynamicContent.content"
                 translationKey="dynamicContent.webcam.previewUrl"></smart-input>
  </ng-container>
</mat-card>
